var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-page bold tablec" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "Widget",
        {
          attrs: { title: "List of countries", fetchingData: _vm.isReceiving }
        },
        [
          _vm.hasRootRole()
            ? _c(
                "b-button",
                {
                  staticClass: "mb-3",
                  attrs: { variant: "success" },
                  on: {
                    click: function($event) {
                      return _vm.$router.push(
                        "/app/admin-console/countries/create"
                      )
                    }
                  }
                },
                [_vm._v("\n            Create new country\n        ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "list-group list-group-lg" },
            _vm._l(_vm.countries, function(country) {
              return _c(
                "div",
                {
                  key: country.id,
                  staticClass: "list-group-item display-flex"
                },
                [
                  _c(
                    "div",
                    { staticClass: "pt-2", staticStyle: { width: "70%" } },
                    [
                      _c("h5", {}, [
                        _vm._v(
                          "\n                        [" +
                            _vm._s(country.code) +
                            "] " +
                            _vm._s(country.name) +
                            "\n                    "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.hasRootRole()
                    ? _c("div", { staticClass: "ml-auto" }, [
                        _c("span", {
                          staticClass: "glyphicon glyphicon-pencil icon-button",
                          on: {
                            click: function($event) {
                              return _vm.$router.push(
                                "/app/admin-console/countries/" + country.id
                              )
                            }
                          }
                        })
                      ])
                    : _vm._e()
                ]
              )
            }),
            0
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-top-line" }, [
      _c("h2", { staticClass: "page-title" }, [
        _vm._v("Countries - "),
        _c("span", { staticClass: "fw-semi-bold" }, [_vm._v("Management")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }